import GridImageDefaultProps from "segments/desktop/core-components/grid-image/default-props";
import titleDefaultProps from "segments/desktop/core-components/title/default-props";
import paragraphDefaultProps from "segments/desktop/core-components/paragraph/default-props";
import { WHITE_COLOR_NAME } from "styles/color-consts";

export default {
  ...GridImageDefaultProps,
  src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png",
  showParagraph: true,
  fullParagraph: { ...titleDefaultProps, ...paragraphDefaultProps },
  cardColor: WHITE_COLOR_NAME
};
